var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"mini-workbench",on:{"click":function($event){return _vm.openWorkbench()}}},[_vm._v("云呼")]),_c('div',{attrs:{"id":"workbench"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }